import React from 'react';
import { Link, NavLink } from 'react-router-dom';

import Body from '../Components/layout/Body';
import { RESOURCES_URL } from './ConstPaths';

//content sub-component with unique content for this page
function StaticAboutContent(props) {
  return(
    <>
    <h4>Access Nav overview</h4>
    <p>Access Navigator is an app that helps you and your clients with physical disabilities make decisions about alternative access, using a structured access process. 
      Clients include peeople with some form of physical disability disability that makes it difficult to use the standard interface for computers, tablets, and similar devices. 
      The app is best-suited for practitioners who have experience with assistive technology (AT) in general and alternative access in particular. 
    </p>
    <h4>A few tips</h4>
    <p><strong>Navigating the app. </strong>The Access Nav app walks you through the entire assessment process. 
      You can go step-by-step simply by hitting Continue at each point. 
      Alternatively, you can jump from place to place using the tabs and subtabs. 
      This can be handy after you've gained some experience with the app. For example, to go to the start of the Gather Info section, hit the Gather Info tab in the navigation bar.
    </p>
    <p><strong>Getting help. </strong>Help is available on just about every page in the app. Look for the Learn More link near the bottom of the page. There are also some supplementary resources, guides, and videos on the <NavLink to={RESOURCES_URL} className="btn-link">Resources</NavLink> page.</p>
    <p><strong>Paper forms. </strong>There may be times when you need or want to use a paper-and-pencil during an assessment instead of running the app on a device. 
      Paper forms are available on the <Link to={RESOURCES_URL} className="btn-link">Resources</Link> page. These forms cannot replicate everything that the app does, but they do allow you to collect and organize very similar information.
    </p>
    <h4>Contact us</h4>
    <p>Access Navigator was developed by an interdisciplinary team at the <a href='https://rerc-aac.psu.edu/' target='_blank' rel='noreferrer' className="btn-link">RERC on AAC</a>. The team includes Heidi Koester, Erik Jakobs, Susan Fager, Jessica Gormley, and Tabatha Sorenson. 
      Please contact us with any questions or suggestions, at accessnavigator@aac-learning-center.org.
    </p>
    <h4>Acknowledgements</h4>
    <p>We are grateful for the many users who provided input and feedback along the way.</p>
    <p>This research was supported by a grant from the National Institute on Disability, Independent Living, and Rehabilitation Research (NIDILRR grant #90REGE0014) to the Rehabilitation Engineering Research Center on Augmentative and Alternative Communication (RERC on AAC). NIDILRR is a Center within the Administration for Community Living (ACL), Department of Health and Human Services (HHS). 
      The contents of this site do not necessarily represent the policy of NIDILRR, ACL, HHS, and you should not assume endorsement by the Federal Government.
    </p>
    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function StaticAbout(props) {

  const pageData = {
    image: "",
    faIcon: "", //fa-user",
    majorHeading: "About Access Navigator",
    title: ``,
    subTitle: "",
    learnMore: {linkText: "",
                title: "",
                content: ""
                },
    nextRoute: "", 
    continueDisabled: true, //we'll only use the Back button on these static pages
    sidebar: false
  }

  console.log("Rendering About page");
  
  return(
    <>
    <Body page={pageData} contentComponent={<StaticAboutContent />} />
    </>
  );
}


export default StaticAbout;